import React from 'react';
import { Card, Collapse, Empty } from 'antd';
import type { ProjectView } from '../types';
import { ProjectPanelBody, ProjectPanelExtra, ProjectPanelHeader } from './ProjectPanel';

interface ProjectListProps {
  projects: ProjectView[];
  redoLoading: Record<string, boolean>;
  onRedoFailedTasks: (projectId?: string) => void;
  onProjectExpand: (key: string | string[]) => void;
  expandingProject: string | null;
  onRefreshProject: (projectId: string) => void;
}

export const ProjectList: React.FC<ProjectListProps> = ({
  projects,
  redoLoading,
  onRedoFailedTasks,
  onProjectExpand,
  expandingProject,
  onRefreshProject,
}) => {
  if (projects.length === 0) {
    return (
      <Card>
        <Empty
          description='No auto render jobs are currently in progress'
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </Card>
    );
  }

  return (
    <Collapse
      accordion
      expandIconPosition='start'
      className='auto-render-dashboard__projects'
      onChange={onProjectExpand}
      items={projects.map((item) => ({
        key: item.key,
        label: (
          <ProjectPanelHeader
            item={item}
            loading={
              expandingProject === item.project.id ||
              expandingProject === item.project.projectId ||
              expandingProject === item.project.pk
            }
            onRefresh={() =>
              onRefreshProject(
                item.project.id || item.project.projectId || item.project.pk || '',
              )
            }
          />
        ),
        extra: <ProjectPanelExtra item={item} />,
        children: (
          <ProjectPanelBody
            item={item}
            redoLoading={redoLoading}
            onRedoFailedTasks={onRedoFailedTasks}
          />
        ),
      }))}
    />
  );
};
